import { createReducer } from "@reduxjs/toolkit";
import {
  DAM_SCHEDULES_GET_ALL,
  DAM_SCHEDULES_GET_BY_ID,
  DAM_SCHEDULES_GET_BY_DATE,
  DAM_SCHEDULES_ADD,
  DAM_SCHEDULES_UPDATE,
  DAM_SCHEDULES_DELETE,
} from "./action";
import { DamSchedule } from "src/types/damSchedule";

export type DamScheduleState = {
  damSchedules: DamSchedule[];
  selectedDamSchedule: DamSchedule | null;
};

export const initialState: DamScheduleState = {
  damSchedules: [],
  selectedDamSchedule: null,
};

const damScheduleReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(DAM_SCHEDULES_GET_ALL, (state, action) => {
      state.damSchedules = action.payload.damSchedules;
    })
    .addCase(DAM_SCHEDULES_GET_BY_DATE, (state, action) => {
      state.damSchedules = action.payload.damSchedules;
    })
    .addCase(DAM_SCHEDULES_GET_BY_ID, (state, action) => {
      state.selectedDamSchedule = action.payload.damSchedule;
    })
    .addCase(DAM_SCHEDULES_ADD, (state, action) => {
      state.damSchedules.push(action.payload.damSchedule);
    })
    .addCase(DAM_SCHEDULES_UPDATE, (state, action) => {
      const updated = action.payload.damSchedule;
      state.damSchedules = state.damSchedules.map((s) =>
        s.damScheduleId === updated.damScheduleId ? updated : s
      );
    })
    .addCase(DAM_SCHEDULES_DELETE, (state, action) => {
      state.damSchedules = state.damSchedules.filter(
        (s) => s.damScheduleId !== action.payload.damScheduleId
      );
    })
);

export default damScheduleReducer;
